import { render } from "./ModalInfo.vue?vue&type=template&id=64f3f3bc&scoped=true"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"

import "./ModalInfo.vue?vue&type=style&index=0&id=64f3f3bc&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f3f3bc"]])

export default __exports__